import { Preloader } from 'mmfintech-portal-commons'

function CustomPreloader() {
  return <Preloader />
}

export default CustomPreloader
